import React from 'react';
import { setModal } from "../actions/app";
import {connect} from 'react-redux';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { TextField, Grid, Link, IconButton, Typography, Divider } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import {formatDate, maskPhone, validateEmail, validatePhoneNumber} from "../utils";
import { Formik } from 'formik';
import Button from './Button';
import {addToCart, addToCartReset} from "../actions/cart";
import ImportRecipientsFromCsvModal from "./Modals/ImportRecipientsFromCsvModal";
import {fetchMerchantPageContent} from '../../src/actions/merchant'
import GiftCard from "./Gift/GiftCardNew";
import CustomizeGiftAddToCartErrorModal from "./Modals/CustomizeGiftAddToCartErrorModal";
import UsPurchaseOnly from '../../src/components/GuestCheckout/USPurchaseOnly'
import WaysToReceive from '../../src/components/WaysToReceive/WaysToReceive'
import LazyLoader from "../../src/components/LazyLoader"
import DeliveryDatePicker from "./DeliveryDatePicker";

const useStyles = makeStyles((theme) => ({
    container: {
        padding:theme.spacing(1)
    },
    h1: {
        fontSize:25, 
        marginTop:'-30px', 
        [theme.breakpoints.up(`md`)]: {
            marginTop:'-20px', 
            fontSize:45
        }
    },
    h2: {
        marginTop: theme.spacing(1),
        fontSize:18, 
        [theme.breakpoints.up(`md`)]: {
            fontSize:24
        }
    },
    quantitySelector: {
        // display: 'inline-block'
        marginBottom: theme.spacing(1)
    },
    quantitySelectorButtonLeft: {
        border: `solid 1px ${theme.palette.grey[600]}`,
        borderTopLeftRadius: '6px',
        borderBottomLeftRadius: '6px',
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        backgroundColor: 'white',
        color: theme.palette.secondary.main,
        minWidth: '50px',
        height: '100%',

    },
    quantitySelectorButtonRight: {
        border: `solid 1px ${theme.palette.grey[600]}`,
        borderTopRightRadius: '6px',
        borderBottomRightRadius: '6px',
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        backgroundColor: 'white',
        color: theme.palette.secondary.main,
        minWidth: '50px',
        height: '100%',

    },
    quantitySelectorCount: {
        border: `solid 1px ${theme.palette.grey[600]}`,
        borderLeft: 'none',
        borderRight: 'none',
        backgroundColor: 'white',
        minWidth: '50px',
        textAlign: 'center',
        lineHeight: '44px'

    },
    numberInputContainer: {
        marginTop: theme.spacing(1)
    },
    addAnotherButton: {
        marginTop: theme.spacing(1)
    },
    warningMessage: {
        marginTop: theme.spacing(2)
    },
    messageTextField: {
        marginBottom: theme.spacing(2)
    },
    stepExtraInfo: {
        color: theme.palette.grey[700],
            [theme.breakpoints.up(`md`)]: {
                paddingLeft: '20px'
            }
    },
    textFieldsAndButtons: {
        maxWidth: '440px'
    },
    heading: {
        display: 'inline-block', 
        fontSize:18,
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(1),
        marginRight:theme.spacing(1),
            [theme.breakpoints.up(`md`)]: {
                fontSize:22,
                marginRight:0,
                marginTop: theme.spacing(5),
                marginBottom: theme.spacing(2),
            }
    },
    root: {
        // padding: `0 ${theme.spacing(3)}px`
    }, 
    deliveryMethodBtn: {
        fontSize:16,
        padding:'.75rem!important', 
        marginRight:'0.25rem!important', 
        border:`2px solid ${theme.palette.grey.lightNeutral}`,
    },
    deliveryMethodBtnActive: {
        fontSize:16,
        padding:'.75rem!important', 
        marginRight:'0.25rem!important', 
        border:`2px solid ${theme.palette.grey.lightNeutral}`,
        background: theme.palette.primary.main, 
        color: 'white', 
        '&:hover': {
            background: theme.palette.primary.dark, 
            color: 'white',
        },
    }, 
    usPurchaseOnlyDesktop: {
        display:'none',
        marginTop: theme.spacing(2),
        [theme.breakpoints.up(`sm`)]: {
            display:'block'
        }
    },
    usPurchaseOnlyMobile: {
        display:'block',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        [theme.breakpoints.up(`sm`)]: {
            display:'none'
        }
    },
    datepicker: {
        '& > label': {
            color: `${theme.palette.primary.main} !important`,
            backgroundColor: 'transparent !important'
        },
        '& .MuiInputBase-root': {
            color: 'rgba(0, 0, 0, 0.87) !important',

            '& > input': {
                color: 'rgba(0, 0, 0, 0.87) !important',
                cursor: 'default !important'
            }
        }
    }
}));

const MaxGiftWarning = ({open, cartCount}) => {
    const classes = useStyles();
    return (
        <Collapse in={open}>
            <Alert severity="warning" className={classes.warningMessage}>
                Max 20 GiftYas per order (including items in your cart)
            </Alert>
        </Collapse>
    )
}

const CustomizeGift = ({
    setModal,
    addToCart,
    addToCartReset,
    addToCartSuccess,
    addToCartError,
    wrappingImage,
    merchantId,
    amount,
    image,
    video,
    title,
    cartCount, 
    fetchMerchantPageContentSuccess,
    fetchMerchantPageContent,
    merchantPageContent,
    addToCartErrorMessage
}) => {
    const classes = useStyles();
    const theme = useTheme()
    const cartLimit = 20 - cartCount;
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [maxWarningOpen, setMaxWarningOpen] = React.useState({sms: false,email:false});
    const [messageLabelCount, setMessageLabelCount] = React.useState(250);
    const [content, setContent] = React.useState(null)
    const [storedRecipients, setStoredRecipients] = React.useState([]);
    const [importing, setImporting] = React.useState(false);
    const [importRecipientInit, setImportRecipientInit] = React.useState(null);
    const [extraErrorMessage, setExtraErrorMessage] = React.useState(null);

    React.useEffect(() => {
        fetchMerchantPageContent({merchantId: merchantId})
    }, [fetchMerchantPageContent, merchantId]);

    React.useEffect(() => {
        if (fetchMerchantPageContentSuccess) {
            setContent(merchantPageContent)
            
        }
    }, [fetchMerchantPageContentSuccess, merchantPageContent]);

    React.useEffect(() => {
        if (addToCartSuccess) {
            window.location = '/cart';
            addToCartReset();
        }
        // eslint-disable-next-line
    }, [addToCartSuccess]);

    React.useEffect(() => {
        if (importRecipientInit) {
            setImportRecipientInit(null);
        }

    }, [importRecipientInit])

    React.useEffect(() => {
        if (addToCartError) {
            setModal('customize-gift-add-to-cart-error-modal');
            if (addToCartErrorMessage) {
                setExtraErrorMessage(addToCartErrorMessage);
            } else {
                setExtraErrorMessage(null);
            }
            setIsSubmitting(false);
            addToCartReset();
        }
        // eslint-disable-next-line
    }, [addToCartError]);

    React.useEffect(() => {
        if (cartCount === 20) {
            setMaxWarningOpen({sms: true,email: true});
        }
        // eslint-disable-next-line
    }, [])

    const handleImportTriggerClick = ({init = null}) => {
        setModal('import-recipients-from-csv');
        setImportRecipientInit(init);
    };

    const trackEvent = ({quantity, merchantId, price, merchantName, variant, category = 'default', location = 'default'}) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'eec.add',
            ecommerce: {
                add: {
                    actionField: {
                        list: `${category} - ${location}`
                    },
                    products: [{
                        id: merchantId,
                        name: merchantName,
                        category,
                        price,
                        variant,
                        brand: merchantName,
                        quantity
                    }]
                }
            }
        });
    }

    const handleAddToCart = (values) => {
        let quantity;
        if (!importing) {
            quantity = values.recipients.sms.filter(a => a).length + values.recipients.email.filter(a => a).length;
        } else {
            quantity = values.importedRecipients.sms.filter(a => a).length + values.importedRecipients.email.filter(a => a).length;
        }

        setIsSubmitting(true);
        trackEvent({
            values,
            merchantId,
            price: amount,
            quantity,
            merchantName: content?.merchant?.name,
            variant: content?.merchant?.national ? 'national' : 'local',
            category: content?.merchant?.categories[0]?.name,
            location: content?.merchant?.address?.locality
        });
        addToCart({
            phone: !importing ? values.recipients.sms : values.importedRecipients.sms,
            email: !importing ? values.recipients.email : values.importedRecipients.email,
            wrapper: wrappingImage,
            merchantId,
            amount,
            image,
            video,
            message: values.message,
            date: values.deliveryDate._d === null ? 'Now' : formatDate(values.deliveryDate._d, 'mm/dd/yyyy', false),
            deliveryMode: importing ? 'import' : values.deliveryMethod,
            regift: 0,
            regiftGiftId: '',
        });
    }

    const useExperiment = (experimentId) => {
        const [variant, setVariant] = React.useState();

        React.useEffect(() => {
          (async () => {
            const intervalId = setInterval(() => {
              if (window.google_optimize !== undefined) {                  
                setVariant(
                  window.google_optimize.get(experimentId)
                );
                clearInterval(intervalId);
              }
            }, 100);
          })();
        }, [experimentId])
        return variant;
      }
    
    const variant = useExperiment('LvcmmerXQ-qqzqh5gcRy-Q');

    return (
        <div className={classes.root}>
        <Grid container spacing={6}>
            <Grid item xs={12} sm={4}>
                <CustomizeGiftAddToCartErrorModal
                    extraErrorMessage={extraErrorMessage}
                />
                <GiftCard
                    image={image}
                    wrappingImage={wrappingImage}
                    title={title}
                    swipeToOpen={true}
                    video={video}
                    gift={{}}
                    tease={variant === '1'}
                />
                <div className={classes.usPurchaseOnlyDesktop}>
                    <UsPurchaseOnly /> 
                </div>
            </Grid>
            <Grid item xs={12} sm={8}>
                <Formik
                    validateOnMount={false}
                    validateOnChange={true}
                    validateOnBlur={true}
                    initialValues={{
                        deliveryMethod: 'sms',
                        // deliveryDate: {_d: formatDate(new Date(), 'M d, Y', false)},
                        deliveryDate: {_d: null},
                        message: '',
                        importedRecipients: {
                            sms: [],
                            email: []
                        },
                        recipients: {
                            sms: [""],
                            email: [""],
                        },
                    }}
                    validate={values => {
                        const emailRecipientsInvalid = {};
                        if (values.deliveryMethod === 'email' && !importing) {
                            for (let key = 0; key < values.recipients.email.length; key++) {
                                if (!validateEmail(values.recipients.email[key])) {
                                    emailRecipientsInvalid[key] = 'Please enter a valid email address';
                                }
                            }
                        }

                        const smsRecipientsInvalid = {};
                        if (values.deliveryMethod === 'sms' && !importing) {
                            for (let key = 0; key < values.recipients.sms.length; key++) {
                                if (!validatePhoneNumber(values.recipients.sms[key])) {
                                    smsRecipientsInvalid[key] = 'Please enter a valid phone number';
                                }
                            }
                        }

                        return {
                            ...(values.deliveryMethod === 'sms' && values.recipients.sms.length === 0 && {recipients: 'You must enter at least one recipient'}),
                            ...(values.message === '' && {message: 'You must enter a message to the recipient'}),
                            ...((Object.keys(smsRecipientsInvalid).length > 0 || Object.keys(emailRecipientsInvalid).length > 0) && {
                                    recipients: {
                                        sms: {...smsRecipientsInvalid},
                                        email: {...emailRecipientsInvalid}
                                    }
                                }
                            ),
                        }
                    }}
                    onSubmit={handleAddToCart}
                >
                    {(
                        {
                            values,
                            errors,
                            touched,
                            handleBlur,
                            handleSubmit,
                            handleChange,
                            setFieldValue,
                            submitForm,
                        }
                    ) => {

                        const increment = () => {
                            if (values.recipients[values.deliveryMethod].length >= cartLimit) {
                                setMaxWarningOpen({
                                    ...maxWarningOpen,
                                    [values.deliveryMethod]: true
                                });
                                return;
                            }

                            values.recipients[values.deliveryMethod].push("");
                            setFieldValue('recipients', {
                                sms: [...values.recipients.sms],
                                email: [...values.recipients.email]
                            });
                        };
                        const decrement = () => {
                            if (values.recipients[values.deliveryMethod].length <= 1) {
                                return;
                            }
                            for (let key = 0; key < values.recipients[values.deliveryMethod].length; key++) {
                                if (values.recipients[values.deliveryMethod][key] === '') {
                                    removePhoneNumber(key);
                                    return;
                                }
                            }
                            removePhoneNumber(values.recipients[values.deliveryMethod].length - 1);
                        };
                        const handleAddAnother = () => {
                            if (!importing) {
                                increment();
                                return;
                            }
                            setModal('import-recipients-from-csv');
                            setImportRecipientInit('add-another');
                        };
                        const removePhoneNumber = (i) => {
                            values.recipients[values.deliveryMethod].splice(i, 1);

                            setFieldValue('recipients', {
                                sms: [...values.recipients.sms],
                                email: [...values.recipients.email],
                            });
                            setMaxWarningOpen({
                                ...maxWarningOpen,
                                [values.deliveryMethod]: false
                            });
                        };
                        const handleRecipientInputChange = (e, i) => {
                            if (values.deliveryMethod === 'sms') {
                                values.recipients[values.deliveryMethod][i] = e.target.value.replace(/\D/g, '').substr(0,10);
                            } else {
                                values.recipients[values.deliveryMethod][i] = e.target.value;
                            }
                            setFieldValue('recipients', {
                                sms: [...values.recipients.sms],
                                email: [...values.recipients.email],
                            });
                        };

                        const handleMessageChange = e => {
                            const newValue = e.target.value.substring(0, 250);
                            setFieldValue('message', newValue);
                            setMessageLabelCount(250 - newValue.length);
                        };

                        const handleRecipientImport = ({recipients}) => {
                            const newRecipientCount = recipients.sms.length + recipients.email.length;
                            setImporting(newRecipientCount > 0);
                            setFieldValue('importedRecipients', {
                                sms: [...recipients.sms],
                                email: [...recipients.email]
                            });
                        };

                        let showAddAnotherButton;
                        if (!importing) {
                            showAddAnotherButton = values.recipients[values.deliveryMethod].length < cartLimit;
                        } else {
                            showAddAnotherButton = (values.importedRecipients.email.length + values.importedRecipients.sms.length) < cartLimit;
                        }

                        return (

                            <form onSubmit={handleSubmit}>
                            <Grid container className={classes.container}>
                                <Grid item xs={12}>
                                    <Typography variant='h1' className={classes.h1}><span style={{color: theme.palette.secondary.main}}>Personalize</span> Your GiftYa</Typography>
                                    <Typography variant='h2' className={classes.h2}>Add the details and recipient information</Typography>
                                    <Typography className={classes.heading} variant="h5" display="inline">1. Choose a delivery method</Typography>
                                    <Typography className={classes.stepExtraInfo} display="inline" gutterBottom={true}><small>Gifts cannot be delivered to yourself{importing && `. Delivery method selection inactive due to CSV upload.`}</small></Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{marginTop: theme.spacing(1)}}>
                                        <Button variant="outlined" 
                                                color="white" 
                                                className={values.deliveryMethod === 'sms' ? classes.deliveryMethodBtnActive : classes.deliveryMethodBtn}
                                                disabled={importing} 
                                                onClick={() => {setFieldValue('deliveryMethod', 'sms')}}>
                                                    Text message
                                        </Button>
                                        <Button  
                                                variant="outlined" 
                                                color="white"                                                 
                                                className={values.deliveryMethod === 'email' ? classes.deliveryMethodBtnActive : classes.deliveryMethodBtn} 
                                                disabled={importing} 
                                                onClick={() => {setFieldValue('deliveryMethod', 'email')}}>
                                                    Email address
                                        </Button>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>

                                    <div>
                                        <Typography className={classes.heading} variant="h5" gutterBottom={true} display="inline">2. Quantity & recipient(s)</Typography>

                                        {cartCount < 20 && (
                                            <>

                                            {!importing && (
                                                <Typography className={classes.stepExtraInfo} display="inline" gutterBottom={true}><small>Want a fast way to send multiple gifts? <Link size="small" onClick={handleImportTriggerClick} color="primary">Import from CSV</Link></small></Typography>
                                            )}

                                            <ImportRecipientsFromCsvModal
                                                importRecipientInit={importRecipientInit}
                                                onRecipientImport={handleRecipientImport}
                                                setStoredRecipients={setStoredRecipients}
                                                storedRecipients={storedRecipients}
                                                cartCount={cartCount}
                                            />
                                            </>
                                        )}
                                    </div>

                                    {importing && (
                                        <Typography gutterBottom={true}>{values.importedRecipients.sms.length + values.importedRecipients.email.length} recipients imported from CSV <Button size="small" color="primary" onClick={() => {handleImportTriggerClick({init: 'upload'})}}>Upload a new file</Button></Typography>
                                    )}

                                    {importing && (
                                        <div>
                                            <Button
                                                className={classes.textFieldsAndButtons}
                                                color="primary" variant="outlined"
                                                fullWidth={true} onClick={() => {handleImportTriggerClick({init: 'edit'})}}
                                            >
                                                View and edit
                                            </Button>
                                        </div>
                                    )}
                                    {!importing && cartCount < 20 && (
                                        <div className={classes.quantitySelector}>
                                            <Grid container>
                                                <Grid item>
                                                    <Button onClick={decrement} className={classes.quantitySelectorButtonLeft}>-</Button>
                                                </Grid>
                                                <Grid item>
                                                    <div className={classes.quantitySelectorCount}>
                                                        {values.recipients[values.deliveryMethod].length}
                                                    </div>
                                                </Grid>
                                                <Grid item>
                                                    <Button onClick={increment} className={classes.quantitySelectorButtonRight}>+</Button>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    )}
                                </Grid>

                                <MaxGiftWarning cartCount={cartCount} open={maxWarningOpen[values.deliveryMethod]}/>

                                {!importing && cartCount < 20 && (
                                    <>
                                    {Array(values.recipients[values.deliveryMethod].length).fill(null).map((x, i) => (
                                        <Grid item xs={12} key={i}>
                                            <div className={classes.numberInputContainer}>
                                                <Grid container alignItems="center">
                                                    <Grid item xs={12}>
                                                        <TextField
                                                            onChange={(e) => {handleRecipientInputChange(e, i)}}
                                                            value={values.deliveryMethod === 'sms' ? maskPhone(values.recipients[values.deliveryMethod][i]) : values.recipients[values.deliveryMethod][i]}
                                                            fullWidth={true}
                                                            label={values.deliveryMethod === 'sms' ? "Recipient's mobile number" : "Recipient's email address"}
                                                            type={values.deliveryMethod === 'sms' ? "tel" : "email" }
                                                            variant="filled"
                                                            className={classes.textFieldsAndButtons}
                                                            error={
                                                                errors.recipients
                                                                && errors.recipients[values.deliveryMethod]
                                                                && errors.recipients[values.deliveryMethod][i]
                                                                && touched.recipients
                                                                && touched.recipients[values.deliveryMethod]
                                                                && touched.recipients[values.deliveryMethod][i]
                                                                && true
                                                            }
                                                            helperText={
                                                                errors.recipients
                                                                && errors.recipients[values.deliveryMethod]
                                                                && errors.recipients[values.deliveryMethod][i]
                                                                && touched.recipients
                                                                && touched.recipients[values.deliveryMethod]
                                                                && touched.recipients[values.deliveryMethod][i]
                                                                && errors.recipients[values.deliveryMethod][i]
                                                            }
                                                        />
                                                    </Grid>
                                                    {i > 0 && (
                                                        <Grid item>
                                                            <IconButton onClick={() => {removePhoneNumber(i)}}>
                                                                <DeleteOutlineIcon color="primary"/>
                                                            </IconButton>
                                                        </Grid>
                                                    )}
                                                </Grid>
                                            </div>
                                        </Grid>
                                    ))}
                                    </>
                                )}

                                {showAddAnotherButton && (
                                    <Grid item xs={12}>
                                        <Button className={classes.addAnotherButton} onClick={handleAddAnother} startIcon={<AddCircleOutlineIcon/>} size="small" color="secondary">Add another recipient</Button>
                                        <MaxGiftWarning cartCount={cartCount} open={maxWarningOpen[values.deliveryMethod]}/>
                                    </Grid>
                                )}

                                <Grid item xs={12}>                
                                    <div>
                                        <Typography className={classes.heading} variant="h5" display="inline">3. Choose a delivery date</Typography>
                                        <Typography className={classes.stepExtraInfo} display="inline" gutterBottom={true}><small>Up to 6 months from today</small></Typography>
                                    </div>

                                    <div className={classes.gridDeliveryDate}>
                                        <DeliveryDatePicker
                                            inputClassName={classes.textFieldsAndButtons}
                                            textFieldClassName={`${classes.datepicker}`}
                                            setFieldValue={setFieldValue}
                                            value={values.deliveryDate._d}
                                            error={errors.deliveryDate && touched.deliveryDate && true}
                                            helperText={(errors.deliveryDate && errors.deliveryDate) || ' '}
                                        />
                                    </div>
                                </Grid>

                                <Grid item xs={12}>
                                    <div>
                                        <Typography className={classes.heading} variant="h5">4. Write a custom message</Typography>
                                    </div>
                                    <TextField
                                        error={errors.message && touched.message && true}
                                        name="message"
                                        label={`Message`}
                                        helperText={(errors.message && touched.message && errors.message) || <Typography component="span" align="right"><small>{messageLabelCount}/250</small></Typography>}
                                        className={`${classes.messageTextField} ${classes.textFieldsAndButtons}`}
                                        onChange={handleMessageChange}
                                        variant="filled" fullWidth={true} multiline={true} value={values.message}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Button
                                        loading={isSubmitting}
                                        disabled={cartCount >= 20 || isSubmitting}
                                        className={classes.textFieldsAndButtons} fullWidth={true} onClick={submitForm} variant="contained" color="primary">Add to cart
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                        );
                    }}
                </Formik>

                <div className={classes.usPurchaseOnlyMobile}>
                    <UsPurchaseOnly /> 
                </div>
            </Grid>
            <LazyLoader>
                {content && (
                    <>
                        <div style={{marginBottom: theme.spacing(4)}}>
                            <Divider />
                        </div>
                        <WaysToReceive content={content} />
                    </>
                )}                                                                      
            </LazyLoader>
        </Grid>
        </div>
    );
};




export default connect(
    (state) => ({
        addToCartSuccess: state.cart.addToCartSuccess,
        addToCartError: state.cart.addToCartError,
        addToCartErrorMessage: state.cart.addToCartErrorMessage,
        fetchMerchantPageContentSuccess: state.merchant.fetchMerchantPageContentSuccess,
        merchantPageContent: state.merchant.fetchMerchantPageContent,
    }),
    {
        setModal,
        addToCart,
        addToCartReset, 
        fetchMerchantPageContent
    }
)(CustomizeGift);